const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Showdata = () => import("@/views/showdata");

export default [
    {
        path: "/showdata",
        name: "showdata",
        component: Main,
        meta: {
            name: "展示数据设置",
            unfold: false, //是否可以被展开
            iconType: "edit"
        },
        redirect: {
            name: "showdataPanel"
        },
        children: [
            {
                path: "",
                name: "showdataPanel",
                component: Showdata,
                meta: {
                    name: "展示数据设置",
                    role:{}
                }
            }
        ]
    }
];